"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFormContext = exports.BroadcastFormContext = void 0;

var withChannel_1 = require("../decorators/withChannel");

var helpers = withChannel_1.createChannel('formContext', {
  insideForm: false
});
var Broadcast = helpers.Broadcast;
exports.BroadcastFormContext = Broadcast;
var withChannel = helpers.withChannel;
exports.withFormContext = withChannel;